import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

if (environment.production) {
  enableProdMode()
}

// Suppress Angular DevTools errors in development
if (!environment.production) {
  // Ensure Angular debugging is properly initialized
  ;(window as any)['ng'] = (window as any)['ng'] || {}

  // Suppress multiple DevTools related console errors
  const originalError = console.error
  console.error = function (...args) {
    if (args[0] && typeof args[0] === 'string') {
      // Suppress Angular DevTools related errors
      if (
        args[0].includes('Angular DevTools: Angular debugging APIs are not available') ||
        args[0].includes('e.getComponent is not a function') ||
        (args[0].includes('TypeError') && args[0].includes('getComponent'))
      ) {
        return // Suppress these specific errors
      }
    }
    originalError.apply(console, args)
  }

  // Also suppress uncaught errors that match the pattern
  window.addEventListener('error', function (event) {
    if (
      event.error &&
      event.error.message &&
      (event.error.message.includes('getComponent is not a function') ||
        event.error.message.includes('Angular debugging APIs are not available'))
    ) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  })
}

if (!!environment?.dataDogConfigRum) {
  try {
    datadogRum.init(environment.dataDogConfigRum)
    datadogRum.startSessionReplayRecording()
  } catch (error) {
    console.error('Error initializing Datadog RUM:', error)
  }
}

if (!!environment?.dataDogConfigLogs) {
  try {
    datadogLogs.init(environment.dataDogConfigLogs)
    datadogLogs.logger.info('Datadog Logs initialized.')
  } catch (error) {
    console.error('Error initializing Datadog Logs:', error)
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error('An unhandled error has been caught.')
    console.error(err)
  })
